import React from 'react';
import ReactDOM from 'react-dom/client';
import Modal from 'react-modal';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Start from './components/Login/Start';

Modal.setAppElement("#root")

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Start/>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
